import { causeError } from 'libs/types/checkTypes';
import { Role, Tab, Type } from '../const';

/**
 * @function filterTabs
 * @param { array } oldTabs
 * @param { array } newTabs
 * @returns { array }
 */
function filterTabs(oldTabs, newTabs) {
	let results = null;

	if (oldTabs) {
		const newArr = oldTabs.filter(
			(oldTab) => !newTabs.some((newTab) => oldTab[Tab.GroupId] === newTab[Tab.GroupId]),
		);
		results = [...newArr, ...newTabs];
	} else {
		results = [...newTabs];
	}

	return results;
}

/**
 * @function filterSubtabs
 * @param { array } oldTabs
 * @param { array } newTabs
 * @returns { array }
 */
function filterSubtabs(oldSubtabs, newSubtabs) {
	let results = null;

	if (oldSubtabs) {
		const newArr = oldSubtabs.filter(
			(oldSubtab) =>
				!newSubtabs.some((newSubtab) => oldSubtab[Tab.GroupId] === newSubtab[Tab.GroupId]),
		);
		results = [...newArr, ...newSubtabs];
	} else {
		results = [...newSubtabs];
	}

	return results;
}

/**
 * @function filterRoles
 * @param { array } oldTabs
 * @param { array } newTabs
 * @returns { array }
 */
function filterRoles(oldRoles, newRoles) {
	let results = null;

	if (oldRoles) {
		const newArr = oldRoles.filter(
			(oldRole) => !newRoles.some((newRole) => oldRole[Role.GroupId] === newRole[Role.GroupId]),
		);
		results = [...newArr, ...newRoles];
	} else {
		results = [...newRoles];
	}

	return results;
}

/**
 * @function handleMenuData
 * @param { string } type - all || tabs || subtabs || roles
 * @param { boolean } progress
 * @param { string } id - groupId
 * @param { array } newValues tabs || subtabs || roles
 * @param { object } data - data.tabs || data.subtabs || data.roles
 * @returns { object }
 */
function handleMenuData(type, progress, id, newValues, data) {
	const newData = Object.assign({}, data);

	switch (type) {
		case Type.Tab:
			if (progress) {
				const results = filterTabs(newData[Type.Tabs], newValues);
				newData[Type.Tabs] = [...results];
			} else {
				const results = newData[Type.Tabs].filter((tab) => tab[Tab.GroupId] !== id);
				newData[Type.Tabs] = [...results];
			}
			break;
		case Type.Subtab:
			if (progress) {
				const results = filterSubtabs(newData[Type.Subtabs], newValues);
				newData[Type.Subtabs] = [...results];
			} else {
				const results = newData[Type.Subtabs].filter((subtab) => subtab[Tab.GroupId] !== id);
				newData[Type.Subtabs] = [...results];
			}
			break;
		case Type.Role:
			if (progress) {
				const results = filterRoles(newData[Type.Roles], newValues);
				newData[Type.Roles] = [...results];
			} else {
				const results = newData[Type.Roles].filter((role) => role[Role.GroupId] !== id);
				newData[Type.Roles] = [...results];
			}
			break;
		default:
			causeError('Cause error at the handleMenuData() method!');
	}

	return newData;
}

export default handleMenuData;
